export default {
  columns: {
    version: 'Versione',
    signed_at: 'Firmato il',
    internal_note: 'Nota interna',
    signature_provider: 'Fornitore firma',
    file: 'Documento',
    actions: 'Azioni',
  },
  labels: {
    version: 'v{{version}}',
    no_history: 'Nessuna cronologia firme disponibile',
    providers: {
      selfhosted: 'Self-hosted',
      yousign: 'Yousign',
    },
  },
  buttons: {
    preview: 'Anteprima',
    download: 'Scarica',
  },
};
